import { TripGrouping } from '../../lib/types/models/trip-grouping/trip-grouping'
import { TripGroupingInput } from '../../lib/types/models/trip-grouping/trip-grouping-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripGrouping(data: TripGroupingInput) {
  return restApiClient
    .url(constructApiUrl(API.tripGroupings.create.url, null))
    .post<TripGrouping, TripGroupingInput>(data)
}
